<template>
  <div class="w-full py-3"
    v-if="broker != null"
    :style="'background-color:' + (broker.header_background != null ? broker.header_background : '#1A356F') + ';'">

    <template v-if="broker.fb_pixel != null">
      <span v-html="getFbPixel" />
    </template>
    
    <div class="flex items-center justify-between w-full px-6 xxl:px-6 xxl:w-3/5 m-auto">
      <template v-if="broker.logo != null">
        <BrokerLogo :broker="broker" />
      </template>
      <template v-else>
        <BrokerpadLogo />
      </template>

      <div class="flex items-center">        
        <template v-if="broker.profile_image != null">
          <img :src="broker.profile_image.url" class="rounded-full w-12 inline mr-4" />
        </template>
        <template v-else>
          <img src="https://img.icons8.com/color/48/000000/test-account.png" class="rounded-full w-12 mr-4 inline" />
        </template>

        <template v-if="$store.state.view == 'broker'">
          <router-link :to="{
            name : 'broker-account',
            params : {
              brokerId : broker.id
            }
          }"
          tag="a"
          class="no-underline flex items-center"
          :style="'color:' + (broker.header_text != null && broker.header_text == 1 ? '#000' : '#fff') + ';'"
          v-tooltip.bottom="{ html : 'user-options', class : 'user-option-class' }">
            <div class="">
              <div class="text-sm font-semibold">{{ broker.first_name }} {{ broker.last_name }}</div>
              <div class="">{{ broker.phone_mobile }}</div>
              <div class="-mt-1">{{ broker.email }}</div>
            </div>
            <svg width="16" height="16" stroke-width="2" class="ml-4" stroke="currentColor" fill="none">
              <use xlink:href="/static/img/feather-sprite.svg#chevron-down"/>
            </svg>
          </router-link>
        </template>

        <template v-else>
          <div class="text-sm"
            :style="'color:' + (broker.header_text != null && broker.header_text == 1 ? '#000' : '#fff') + ';'">
            <div class="text-sm font-semibold">{{ broker.user.first_name }} {{ broker.user.last_name }}</div>
            <div class="">{{ broker.phone_mobile }}</div>
            <div class="-mt-1">{{ broker.user.email }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import BrokerLogo     from '@/shared/components/BrokerLogo';
  import BrokerpadLogo  from '@/shared/components/BrokerpadLogo';

  export default {

    components: {
      BrokerpadLogo,
      BrokerLogo
    },

    props : {
      broker : {
        type    : Object,
        required: true
      }
    },

    computed : {
      getFbPixel() {
        if(this.broker.fb_pixel != null) {
          return atob(this.broker.fb_pixel)
        }
      }
    }
  }
</script>